module.exports = __webpack_public_path__ + "static/media/D670MeldrumStNW_2018-06-18_113.78921ddd.jpg";